import { type NavigateOptions, useNavigate, useRouter } from '@tanstack/react-router'
import { useCallback } from 'react'

export const useNavigateBack = () => {
	const navigate = useNavigate()
	const router = useRouter()

	return useCallback(
		({ fallback }: { fallback: NavigateOptions['to'] }) => {
			if (!router.history.canGoBack()) return navigate({ to: fallback, replace: true })
			// history.back() returns immediately, resolve once the previous page is rendered like navigate() does
			return new Promise<void>((resolve) => {
				const unsubscribe = router.subscribe('onResolved', () => {
					unsubscribe()
					resolve()
				})
				router.history.back()
			})
		},
		[navigate, router],
	)
}
